/**
 * Horizontal rail scroll — shared by Magio Collections + Salon Services.
 * Root: [data-magio-rail-scroll]
 */
(function () {
  function init(root) {
    if (!root || root.dataset.magioRailScrollInit === '1') return;
    var grid = root.querySelector('[data-magio-rail-grid]');
    var btnPrev = root.querySelector('[data-magio-rail-prev]');
    var btnNext = root.querySelector('[data-magio-rail-next]');
    var fill = root.querySelector('[data-magio-rail-progress-fill]');
    var footRow = root.querySelector('[data-magio-rail-foot-row]');
    if (!grid || !footRow) return;

    root.dataset.magioRailScrollInit = '1';

    var cardSelector = root.getAttribute('data-rail-card') || '[data-magio-rail-card]';
    var copySelector = root.getAttribute('data-rail-copy') || '';
    var progressPrefix = root.getAttribute('data-rail-progress-prefix') || 'mc';
    var mobileMq = root.getAttribute('data-rail-mobile-mq') || '(max-width: 989px)';

    function isMobileRail() {
      return window.matchMedia(mobileMq).matches;
    }

    function cardCopyInsetPx() {
      var card = grid.querySelector(cardSelector);
      if (!copySelector || !card) return 24;
      var copy = card.querySelector(copySelector);
      if (!copy) return 24;
      return copy.getBoundingClientRect().left - card.getBoundingClientRect().left;
    }

    function setProgressVar(suffix, value) {
      footRow.style.setProperty('--' + progressPrefix + '-progress-' + suffix, value);
    }

    function syncProgressLayout() {
      var gr = grid.getBoundingClientRect();
      var fr = footRow.getBoundingClientRect();
      var pl = parseFloat(window.getComputedStyle(grid).paddingLeft) || 0;
      var trackLeft;
      if (isMobileRail()) {
        trackLeft = gr.left + pl + cardCopyInsetPx() - fr.left;
      } else {
        trackLeft = gr.left + pl - fr.left;
      }
      var trackW = fr.width - trackLeft;
      if (trackW > 0 && isFinite(trackLeft) && trackLeft >= 0) {
        setProgressVar('left', trackLeft + 'px');
        setProgressVar('w', trackW + 'px');
      }
    }

    function stepSize() {
      var card = grid.querySelector(cardSelector);
      if (!card) return Math.min(400, grid.clientWidth * 0.85);
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, grid.scrollWidth - grid.clientWidth);
    }

    function updateProgress() {
      if (!fill) return;
      var cards = grid.querySelectorAll(cardSelector);
      var count = cards.length;
      if (count <= 1) {
        fill.style.width = count === 1 ? '100%' : '0%';
        return;
      }
      if (isMobileRail()) {
        var stepPct = 100 / count;
        var max = maxScroll();
        fill.style.width = stepPct + '%';
        if (max <= 2) {
          fill.style.left = '0';
        } else {
          fill.style.left = (grid.scrollLeft / max) * (100 - stepPct) + '%';
        }
        return;
      }
      fill.style.left = '0';
      var sw = grid.scrollWidth;
      var cw = grid.clientWidth;
      if (sw <= 0 || cw <= 0) {
        fill.style.width = '0%';
        return;
      }
      var ratio = (grid.scrollLeft + cw) / sw;
      fill.style.width = Math.min(100, Math.max(0, ratio * 100)) + '%';
    }

    function updateNav() {
      syncProgressLayout();
      updateProgress();

      var max = maxScroll();
      var left = grid.scrollLeft;
      var eps = 2;
      var canScrollPrev = left > eps;
      var canScrollNext = left < max - eps;

      if (btnPrev && btnNext) {
        btnPrev.classList.remove('is-primary', 'is-secondary');
        btnNext.classList.remove('is-primary', 'is-secondary');

        if (max <= eps) {
          btnPrev.disabled = true;
          btnNext.disabled = true;
          return;
        }

        btnPrev.disabled = !canScrollPrev;
        btnNext.disabled = !canScrollNext;

        /* Highlight the direction that can scroll: Next (black) while forward exists; at end, Previous (black). */
        if (canScrollNext) {
          btnNext.classList.add('is-primary');
          if (canScrollPrev) {
            btnPrev.classList.add('is-secondary');
          }
        } else if (canScrollPrev) {
          btnPrev.classList.add('is-primary');
        }
      }
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        grid.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        grid.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });
    }

    var scrollEndTimer;
    grid.addEventListener(
      'scroll',
      function () {
        if (fill && isMobileRail()) fill.style.transition = 'none';
        updateNav();
        clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(function () {
          if (fill && isMobileRail()) fill.style.transition = '';
        }, 100);
      },
      { passive: true }
    );
    if ('onscrollend' in window) {
      grid.addEventListener('scrollend', updateNav, { passive: true });
    }
    window.addEventListener('resize', updateNav, { passive: true });
    window.addEventListener('load', updateNav, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(updateNav);
      ro.observe(grid);
      ro.observe(footRow);
    }
    updateNav();
    requestAnimationFrame(function () {
      requestAnimationFrame(updateNav);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-magio-rail-scroll]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
